import StoreBoxes from './box/storeBoxes';
import StoreReports from './storeReports';
import AuthStore from 'stores/AuthStore';
import SearchStore from 'stores/SearchStore';
import LicenseStore from 'stores/./LicenseStore';
import AgentListStore from 'stores/agent/AgentListStore';
import StoreTaskList from 'stores/task/TaskListStore';
import AccessTokenListStore from 'stores/accessToken/AccessTokenListStore';
import PersonalAccessTokenListStore from 'stores/accessToken/PersonalAccessTokenListStore';
import TargetGroupListStore from 'stores/targetGroup/TargetGroupListStore';
import UserListStore from 'stores/user/UserListStore';
import UserActivityListStore from 'stores/userActivity/UserActivityListStore';
import LicenseAuditListStore from 'stores/licenseAudit/LicenseAuditListStore';
import ExtensionListStore from 'stores/extension/ExtensionListStore';
import ExtensionVersionListStore from 'stores/extensionVersion/ExtensionVersionListStore';
import ProcessListStore from 'stores/process/ProcessListStore';
import ModuleListStore from 'stores/module/ModuleListStore';
import AutostartListStore from 'stores/autostart/AutostartListStore';
import DriverListStore from 'stores/driver/DriverListStore';
import ArtifactListStore from 'stores/artifact/ArtifactListStore';
import ExtensionResultListStore from 'stores/extensionResult/ExtensionResultListStore';
import AccountListStore from 'stores/account/AccountListStore';
import WebhookListStore from 'stores/webook/WebhookListStore';
import HostListStore from 'stores/host/HostListStore';
import MemoryListStore from 'stores/memory/MemoryListStore';
import ConnectionListStore from 'stores/connection/ConnectionListStore';
import AgentRegistrationKeyListStore from 'stores/agentRegistrationKeys/AgentRegistrationKeyListStore';
import ControllerListStore from 'stores/controller/ControllerListStore';
import TenantInfoStore from 'stores/tentantInfo/TenantInfoStore';
import ScriptListStore from 'stores/script/ScriptListStore';
import FlagListStore from 'stores/flag/FlagListStore';
import ApplicationListStore from 'stores/application/ApplicationListStore';
import StatListStore from 'stores/stat/StatListStore';
import DwellTimeListStore from 'stores/dwellTime/DwellTimeListStore';
import CommentListStore from 'stores/comment/CommentListStore';
import NotificationListStore from 'stores/notification/NotificationListStore';
import AdminNotificationListStore from 'stores/adminNotification/AdminNotificationListStore';
import SettingsStore from 'stores/settings/SettingsStore';
import ExtensionAggregationListStore from 'stores/extensionResult/ExtensionAggregationListStore';
import AnalysisStore from 'stores/analysis/AnalysisStore';
import BoxListStore from 'stores/box/BoxListStore';
import ExtensionResponseListStore from 'stores/extensionResponse/ExtensionResponseListStore';
import ExtensionResponseQueueListStore from 'stores/extensionResponseQueue/ExtensionResponseQueueListStore';
import ExtensionGlobalVariableListStore from 'stores/extensionGlobalVariable/ExtensionGlobalVariableListStore';
import LoadingStore from 'stores/loading/LoadingStore';
import IntegrationListStore from 'stores/integration/IntegrationListStore';
import NavigationStore from 'stores/navigation/NavigationStore';
import BmsIntegrationStore from 'stores/bmsIntegration/BmsIntegrationStore';
import AutotaskIntegrationStore from 'stores/autotaskIntegration/AutotaskIntegrationStore';
import VsaXIntegrationStore from 'stores/vsaxIntegration/VsaXIntegrationStore';
import DialogStore from 'stores/dialog/DialogStore';
import ReportListStore from 'stores/report/ReportListStore';
import AlertListStore from 'stores/alert/AlertListStore';
import SystemNotificationListStore from 'stores/systemNotification/SystemNotificationListStore';
import QuarantinedFileListStore from 'stores/quarantinedFile/QuarantinedFileListStore';
import AlertSourceStore from 'stores/alertSource/AlertSourceStore';
import RulePublishHistoryListStore from 'stores/rule/RulePublishHistoryListStore';
import RuleListStore from 'stores/rule/RuleListStore';
import RuleVersionListStore from 'stores/rule/RuleVersionListStore';
import OrganizationListStore from 'stores/organization/OrganizationListStore';
import LocationListStore from 'stores/location/LocationListStore';
import DeviceListStore from 'stores/device/DeviceListStore';
import DeviceGroupListStore from 'stores/deviceGroup/DeviceGroupListStore';
import SuppressionRulePublishHistoryListStore from 'stores/suppressionRule/SuppressionRulePublishHistoryListStore';
import SuppressionRuleListStore from 'stores/suppressionRule/SuppressionRuleListStore';
import SuppressionRuleVersionListStore from 'stores/suppressionRule/SuppressionRuleVersionListStore';
import PolicyListStore from 'stores/policy/PolicyListStore';
import FileListStore from 'stores/file/FileListStore';
import HistorySearchListStore from 'stores/history/HistorySearchListStore';
import ScriptSearchListStore from 'stores/script/ScriptSearchListStore';
import AccountSearchListStore from 'stores/account/AccountSearchListStore';
import HostSearchListStore from 'stores/host/HostSearchListStore';
import MemorySearchListStore from 'stores/memory/MemorySearchListStore';
import ConnectionSearchListStore from 'stores/connection/ConnectionSearchListStore';
import ApplicationSearchListStore from './application/ApplicationSearchListStore';
import FileSearchListStore from 'stores/file/FileSearchListStore';
import BreadcrumbStore from 'stores/breadcrumbs/BreadcrumbStore';
import ScheduledReportListStore from 'stores/report/ScheduledReportListStore';
import ResponseOverrideListStore from './responseOverrideStore/responseOverrideListStore';
import AvListStore from './avSubmissionStore/AvSubmissionListStore';
import AvExclusionListStore from './avExclusion/AvExclusionListStore';
import TableViewStore from './tableView/tableViewStore';

// global mobx parent store
class RootStore {
    boxStore: StoreBoxes;
    reportStore: StoreReports;
    userListStore: UserListStore;
    authStore: AuthStore;
    searchStore: SearchStore;
    licenseStore: LicenseStore;
    taskListStore: StoreTaskList;
    agentListStore: AgentListStore;
    targetGroupListStore: TargetGroupListStore;
    accessTokenListStore: AccessTokenListStore;
    personalAccessTokenListStore: PersonalAccessTokenListStore;
    userActivityListStore: UserActivityListStore;
    licenseAuditListStore: LicenseAuditListStore;
    extensionListStore: ExtensionListStore;
    extensionVersionListStore: ExtensionVersionListStore;
    extensionResultListStore: ExtensionResultListStore;
    extensionAggregationListStore: ExtensionAggregationListStore;
    processListStore: ProcessListStore;
    historySearchListStore: HistorySearchListStore;
    moduleListStore: ModuleListStore;
    autostartListStore: AutostartListStore;
    driverListStore: DriverListStore;
    artifactListStore: ArtifactListStore;
    accountListStore: AccountListStore;
    accountSearchListStore: AccountSearchListStore;
    webhookListStore: WebhookListStore;
    hostListStore: HostListStore;
    hostSearchListStore: HostSearchListStore;
    memoryListStore: MemoryListStore;
    memorySearchListStore: MemorySearchListStore;
    connectionListStore: ConnectionListStore;
    connectionSearchListStore: ConnectionSearchListStore;
    agentRegistrationKeyListStore: AgentRegistrationKeyListStore;
    controllerListStore: ControllerListStore;
    tenantInfoStore: TenantInfoStore;
    flagListStore: FlagListStore;
    scriptListStore: ScriptListStore;
    scriptSearchListStore: ScriptSearchListStore;
    applicationListStore: ApplicationListStore;
    applicationSearchListStore: ApplicationSearchListStore;
    statListStore: StatListStore;
    dwellTimeListStore: DwellTimeListStore;
    commentListStore: CommentListStore;
    extensionResponseListStore: ExtensionResponseListStore;
    extensionResponseQueueListStore: ExtensionResponseQueueListStore;
    extensionGlobalVariableListStore: ExtensionGlobalVariableListStore;
    notificationListStore: NotificationListStore;
    adminNotificationListStore: AdminNotificationListStore;
    settingsStore: SettingsStore;
    analysisStore: AnalysisStore;
    boxListStore: BoxListStore;
    loadingStore: LoadingStore;
    integrationListStore: IntegrationListStore;
    navigationStore: NavigationStore;
    bmsIntegrationStore: BmsIntegrationStore;
    autotaskIntegrationStore: AutotaskIntegrationStore;
    vsaXIntegrationStore: VsaXIntegrationStore;
    dialogStore: DialogStore;
    reportListStore: ReportListStore;
    scheduledReportListStore: ScheduledReportListStore;
    alertListStore: AlertListStore;
    systemNotificationListStore: SystemNotificationListStore;
    alertSourceStore: AlertSourceStore;
    quarantinedFileListStore: QuarantinedFileListStore;
    ruleListStore: RuleListStore;
    organizationListStore: OrganizationListStore;
    locationListStore: LocationListStore;
    deviceListStore: DeviceListStore;
    deviceGroupListStore: DeviceGroupListStore;
    policyListStore: PolicyListStore;
    rulePublishHistoryListStore: RulePublishHistoryListStore;
    ruleVersionListStore: RuleVersionListStore;
    suppressionRuleListStore: SuppressionRuleListStore;
    suppressionRulePublishHistoryListStore: SuppressionRulePublishHistoryListStore;
    suppressionRuleVersionListStore: SuppressionRuleVersionListStore;
    fileListStore: FileListStore;
    fileSearchListStore: FileSearchListStore;
    breadcrumbStore: BreadcrumbStore;
    responseOverrideListStore: ResponseOverrideListStore;
    avListStore: AvListStore;
    avExclusionListStore: AvExclusionListStore;
    tableViewStore: TableViewStore;

    constructor() {
        this.boxStore = new StoreBoxes();
        this.reportStore = new StoreReports();
        this.userListStore = new UserListStore();
        this.authStore = new AuthStore();
        this.searchStore = new SearchStore();
        this.licenseStore = new LicenseStore();
        this.taskListStore = new StoreTaskList();
        this.agentListStore = new AgentListStore();
        this.targetGroupListStore = new TargetGroupListStore();
        this.accessTokenListStore = new AccessTokenListStore();
        this.personalAccessTokenListStore = new PersonalAccessTokenListStore();
        this.userActivityListStore = new UserActivityListStore();
        this.licenseAuditListStore = new LicenseAuditListStore();
        this.extensionListStore = new ExtensionListStore();
        this.extensionVersionListStore = new ExtensionVersionListStore();
        this.extensionResultListStore = new ExtensionResultListStore();
        this.extensionAggregationListStore = new ExtensionAggregationListStore();
        this.processListStore = new ProcessListStore();
        this.historySearchListStore = new HistorySearchListStore();
        this.moduleListStore = new ModuleListStore();
        this.autostartListStore = new AutostartListStore();
        this.driverListStore = new DriverListStore();
        this.artifactListStore = new ArtifactListStore();
        this.accountListStore = new AccountListStore();
        this.accountSearchListStore = new AccountSearchListStore();
        this.webhookListStore = new WebhookListStore();
        this.hostListStore = new HostListStore();
        this.hostSearchListStore = new HostSearchListStore();
        this.memoryListStore = new MemoryListStore();
        this.memorySearchListStore = new MemorySearchListStore();
        this.connectionListStore = new ConnectionListStore();
        this.connectionSearchListStore = new ConnectionSearchListStore();
        this.agentRegistrationKeyListStore = new AgentRegistrationKeyListStore();
        this.controllerListStore = new ControllerListStore();
        this.tenantInfoStore = new TenantInfoStore();
        this.flagListStore = new FlagListStore();
        this.scriptListStore = new ScriptListStore();
        this.scriptSearchListStore = new ScriptSearchListStore();
        this.applicationListStore = new ApplicationListStore();
        this.applicationSearchListStore = new ApplicationSearchListStore();
        this.statListStore = new StatListStore();
        this.dwellTimeListStore = new DwellTimeListStore();
        this.commentListStore = new CommentListStore();
        this.notificationListStore = new NotificationListStore();
        this.adminNotificationListStore = new AdminNotificationListStore();
        this.settingsStore = new SettingsStore();
        this.analysisStore = new AnalysisStore();
        this.boxListStore = new BoxListStore();
        this.loadingStore = new LoadingStore();
        this.integrationListStore = new IntegrationListStore();
        this.navigationStore = new NavigationStore();
        this.bmsIntegrationStore = new BmsIntegrationStore();
        this.autotaskIntegrationStore = new AutotaskIntegrationStore();
        this.vsaXIntegrationStore = new VsaXIntegrationStore();
        this.dialogStore = new DialogStore();
        this.reportListStore = new ReportListStore();
        this.scheduledReportListStore = new ScheduledReportListStore();
        this.alertListStore = new AlertListStore();
        this.systemNotificationListStore = new SystemNotificationListStore();
        this.alertSourceStore = new AlertSourceStore();
        this.quarantinedFileListStore = new QuarantinedFileListStore();
        this.ruleListStore = new RuleListStore();
        this.organizationListStore = new OrganizationListStore();
        this.locationListStore = new LocationListStore();
        this.deviceListStore = new DeviceListStore();
        this.deviceGroupListStore = new DeviceGroupListStore();
        this.policyListStore = new PolicyListStore();
        this.rulePublishHistoryListStore = new RulePublishHistoryListStore();
        this.ruleVersionListStore = new RuleVersionListStore();
        this.suppressionRuleListStore = new SuppressionRuleListStore();
        this.suppressionRulePublishHistoryListStore = new SuppressionRulePublishHistoryListStore();
        this.suppressionRuleVersionListStore = new SuppressionRuleVersionListStore();
        this.fileListStore = new FileListStore();
        this.extensionResponseListStore = new ExtensionResponseListStore();
        this.extensionResponseQueueListStore = new ExtensionResponseQueueListStore();
        this.extensionGlobalVariableListStore = new ExtensionGlobalVariableListStore();
        this.fileSearchListStore = new FileSearchListStore();
        this.breadcrumbStore = new BreadcrumbStore();
        this.responseOverrideListStore = new ResponseOverrideListStore();
        this.avListStore = new AvListStore();
        this.avExclusionListStore = new AvExclusionListStore();
        this.tableViewStore = new TableViewStore();
    }
}

const rootStore = new RootStore();

export default rootStore;
